import {html} from "../../../admin/script/libs/lit.dist.js";
import {formatCurrency} from "../../util/number.js";
import '../../../admin/script/custom-elements/pk-spinner.js';

export default props => html`
    <div class="row">
        <div class="col-6 col-md-3 mb-3 mb-md-0">
            <div class="card h-100 shadow-sm">
                <div class="card-body h-100 text-center d-flex flex-column">
                    <i class="pk-svg-icon pk-svg-icon-truck-fast-alt width-4 height-3 mx-auto" style="background-color: var(--pk-color)"></i>
                    <div class="mt-2">
                        Oczekujące
                        <i class="bi bi-info-circle text-muted d-none d-md-inline" title="Pobrania do przesyłek nieodebranych / w przewozie / doręczonych, dla których termin wypłaty jeszcze nie minął."></i>
                        <div class="d-md-none fs-nano">Pobrania do przesyłek nieodebranych / w przewozie / doręczonych, dla których termin wypłaty jeszcze nie minął.</div>
                    </div>
                    <div class="fw-bold text-primary text-center mt-auto">
                        ${props.isRequested ? html`<pk-spinner size="sm"></pk-spinner>` : formatCurrency(props.waiting_amount || 0)} zł
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 col-md-3 mb-3 mb-md-0">
            <div class="card h-100 shadow-sm">
                <div class="card-body h-100 text-center d-flex flex-column">
                    <i class="pk-svg-icon pk-svg-icon-money width-4 height-3 mx-auto" style="background-color: var(--pk-color)"></i>
                    <div class="mt-2">
                        Dostępne do wypłaty
                        <i class="bi bi-info-circle text-muted d-none d-md-inline" title="Przesyłka dostarczona, termin na zwrot od przewoźnika minął, oczekuje na zlecenie przelewu"></i>
                        <div class="d-md-none fs-nano">Przesyłka dostarczona, termin na zwrot od przewoźnika minął, oczekuje na zlecenie przelewu</div>
                    </div>
                    <div class="fw-bold text-primary text-center mt-auto">
                        ${props.isRequested ? html`<pk-spinner size="sm"></pk-spinner>` : formatCurrency(props.available_for_payout_amount || 0)} zł
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 col-md-3 mb-3 mb-md-0">
            <div class="card h-100 shadow-sm">
                <div class="card-body h-100 text-center d-flex flex-column">
                    <i class="pk-svg-icon pk-svg-icon-money width-4 height-3 mx-auto" style="background-color: var(--pk-color)"></i>
                    <div class="mt-2">
                        W drodze
                        <i class="bi bi-info-circle text-muted d-none d-md-inline" title="Wszystkie pobrania zlecone w banku do wypłaty."></i>
                        <div class="d-md-none fs-nano">Wszystkie pobrania zlecone w banku do wypłaty.</div>
                    </div>
                    <div class="fw-bold text-primary text-center mt-auto">
                        ${props.isRequested ? html`<pk-spinner size="sm"></pk-spinner>` : formatCurrency(props.payout_in_progress_amount || 0)} zł
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 col-md-3 mb-3 mb-md-0">
            <div class="card h-100 shadow-sm">
                <div class="card-body h-100 text-center d-flex flex-column">
                    <i class="pk-svg-icon pk-svg-icon-piggy-bank width-4 height-3 mx-auto" style="background-color: var(--pk-color)"></i>
                    <div class="mt-2">
                        W skarbonce
                        <i class="bi bi-info-circle text-muted d-none d-md-inline" title="Wszystkie pobrania, które zostały dodane do skarbonki pobrań"></i>
                        <div class="d-md-none fs-nano">Wszystkie pobrania, które zostały dodane do skarbonki pobrań.</div>
                    </div>
                    <div class="mt-n2">
                        <a href="${props.paths.get('user_cod_money_box')}" class="fs-sm">zarządzaj skarbonką</a>
                    </div>
                    <div class="fw-bold text-primary text-center mt-auto">
                        ${props.isRequested ? html`<pk-spinner size="sm"></pk-spinner>` : formatCurrency(props.money_box_cod || 0)} zł
                    </div>
                </div>
            </div>
        </div>
    </div>
`;
